import "./ResourcesPanel.scss";
import { useTranslation } from "react-i18next";
import { IconArrowPoint } from "../../../../../common/icons/IconArrowPoint/IconArrowPoint";
import { IconArrowLink } from "../../../../../common/icons/IconArrowLink/IconArrowLink";
import defaultContent from "../../../../../content/profileSelectorDropdown";
import defaultNavContent from "../../../../../content/navigation";
import commonContent from "../../../../../content/common";
import type { ProfileMenuResourceLink } from "../../../../../common/util/Navigation/profileMenuResources";

interface ResourcesPanelProps {
  onBack: () => void;
  links: ProfileMenuResourceLink[];
}

export const ResourcesPanel = ({ onBack, links }: ResourcesPanelProps) => {
  const { t } = useTranslation(["profileSelectorDropdown", "navigation", "common"]);
  const disclaimerSymbol = String(
    t("disclaimerSymbol", { defaultValue: commonContent.disclaimerSymbol, ns: "common" }),
  );

  return (
    <div className="ResourcesPanel">
      <div className="ResourcesPanel__header">
        <button
          type="button"
          className="ResourcesPanel__back"
          onClick={onBack}
          aria-label={t("back", defaultContent.back)}
        >
          <IconArrowPoint />
        </button>
        <span className="ResourcesPanel__title">{t("resources", defaultContent.resources)}</span>
      </div>

      <div className="ResourcesPanel__list" role="list">
        {links.map((link) => (
          <button
            key={link.url}
            type="button"
            className="ResourcesPanel__item"
            onClick={() => window.open(link.url, "_blank", "noopener,noreferrer")}
          >
            <span className="ResourcesPanel__item-label">
              {String(
                t(
                  `navigation:linkTitle.${link.labelKey}`,
                  defaultNavContent.linkTitle[link.labelKey as keyof typeof defaultNavContent.linkTitle] ??
                    link.labelKey,
                  { symbol: disclaimerSymbol },
                ),
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
